import { render } from "./ChangeRequestConfirmationModal.vue?vue&type=template&id=dfa76dac"
import script from "./ChangeRequestConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ChangeRequestConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__